import React from "react";
import { Box } from "@chakra-ui/react";

// Filters
import FilterForm from "../components/FilterForm";

// Reports
// organization
import OrganizationTickets from "./organization/OrganizationTickets";
import TicketsPerService from "./organization/OrganizationTicketsPerService";
import ServiceTimePerService from "./organization/OrganizationServiceTimePerService";
import OrganizationWaitingTime from "./organization/OrganizationWaitingTime";
import WaitingTimePerService from "./organization/OrganizationWaitingTimePerService";

import TicketsPerServiceBranches from "./branches/BranchTicketsPerService";
import ServiceTimePerServiceBranches from "./branches/BranchServiceTimePerService";
import WaitingTimePerServiceBranches from "./branches/BranchWaitingTimePerService";
import ArrivalRatesPerHour from "./organization/OrganizationArrivalRatesPerHour";
import ArrivalRatesPerDay from "./organization/OrganizationArrivalRatesPerDay";
import ArrivalRatesPerService from "./organization/OrganizationArrivalRatesPerService";
import TicketsPerBranch from "./organization/OrganizationTicketsPerBranch";
import AgentServiceTimePerService from "./branches/BranchAgentServiceTimePerService";
import AgentTicketsByService from "./branches/BranchAgentTicketsPerService";
import BranchesArrivalRatesPerDay from "./branches/BranchArrivalRatesPerDay";
import BranchesArrivalRatesPerHour from "./branches/BranchArrivalRatesPerHour";
import BranchesArrivalRatesPerService from "./branches/BranchArrivalRatesPerService";
import TicketsPerAgents from "./branches/BranchTicketsPerAgent";
import BranchCustomersInBranchPerHour from "./branches/BranchCustomersInBranchPerHour";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { getReportRangeString } from "../store/helpers";

const FullReport = () => {
  const { reportRange } = useSelector((state) => state.defaultReducer);

  const report = [
    <OrganizationTickets />,
    <TicketsPerService />,
    <ServiceTimePerService />,
    <OrganizationWaitingTime />,
    <WaitingTimePerService />,
    <ArrivalRatesPerHour />,
    <ArrivalRatesPerDay />,
    <ArrivalRatesPerService />,
    <TicketsPerBranch />,
    <TicketsPerServiceBranches />,
    <ServiceTimePerServiceBranches />,
    <WaitingTimePerServiceBranches />,
    <AgentServiceTimePerService />,
    <AgentTicketsByService />,
    <BranchesArrivalRatesPerDay />,
    <BranchesArrivalRatesPerHour />,
    <BranchesArrivalRatesPerService />,
    <TicketsPerAgents />,
    <BranchCustomersInBranchPerHour />,
  ];
  return (
    <Box>
      <Helmet>
        <title>{getReportRangeString(reportRange)} Full Report</title>
      </Helmet>
      <FilterForm />
      {report.map((a, index) =>
        React.cloneElement(a, {
          key: index,
          
          showFilterForm: 0,
          showTitle: 0,
        })
      )}
    </Box>
  );
};

export default FullReport;
